import { ProductionVendorSnapshot } from '@/components/Approval/@components/ProductionVendor';
import { parseProductionVendorContent } from '@/utils/approval/productionVendor';
import type { ContentExtraProps } from '../../types';
import { ContentSlotRoot } from '../styles';

/** 120 GERP 생산거래처 신규/변경 — 저장 본문 그대로(레거시 문서 포함). GERP 재조회 안 함 */
const ProductionVendorSlot = ({ data }: ContentExtraProps) => {
  const content = parseProductionVendorContent(data.attributes);
  if (!content) return null;
  return (
    <ContentSlotRoot>
      <ProductionVendorSnapshot content={content} />
    </ContentSlotRoot>
  );
};

export default ProductionVendorSlot;
